/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Avatar, makeStyles, Theme } from '@material-ui/core';
import { StyledText } from '../../../../components/StyledText';
import { ReferralStatus } from '../../../../types/types';
import StatusChip from '../../../../components/StatusChip';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  root: {
    width: '100%',
    marginTop: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'

  },
  clickableContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover .MuiTypography-body1': {
      color: theme.palette.secondary.main
    }
  },
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  nameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '8px'
  }
}));
export interface InvestorItemProps {
  profileImage: string
  contactName: string
  companyName: string
  status?: ReferralStatus
  showStatus?: boolean
  goToProfile?: () => void
}

const titleMap: Record<ReferralStatus, string> = {
  [ReferralStatus.Pending]: 'Waiting',
  [ReferralStatus.Accepted]: 'Interested',
  [ReferralStatus.Declined]: 'Passed',
  [ReferralStatus.Requested]: 'Requested'
};

export const InvestorItem: React.FC<InvestorItemProps> = ({
  profileImage,
  contactName,
  companyName,
  status,
  showStatus = false,
  goToProfile
}) => {
  const styles = useStyles();
  const clickable = goToProfile != null;

  return (
    <div className={styles.root}>
      <div onClick={goToProfile} className={clickable ? styles.clickableContainer : styles.container}>
        <Avatar src={profileImage} />
        <div className={styles.nameWrapper}>
          <StyledText variant='subtitle3' component='div'>
            {contactName}
          </StyledText>
          <StyledText variant='subtitle1' component='div'>
            {companyName}
          </StyledText>
        </div>
      </div>
      {showStatus && !!status && <div style={{ minWidth: '125px' }}><StatusChip title={titleMap[status]} status={status} /></div>}
    </div>
  );
};
